// Azuro Market Groups based on markets.js functional types

export interface AzuroMarketGroup {
  id: string
  label: string
  marketKeys: string[]
  description?: string
}

export const AZURO_MARKET_GROUPS: AzuroMarketGroup[] = [
  {
    id: "full_time_result",
    label: "Full Time Result",
    marketKeys: [
      "1-1-1", // Full Time Result
      "2-1-1", // Double Chance
      "19-1-1", // Draw no bet
      "19-1-69",
      "19-1-76",
      "19-1-82",
      "19-1-83",
      "19-1-87", // Match Winner variants
      "19-30-1",
      "19-75-51",
      "19-76-1",
      "19-76-83", // Match Winner variants
      "19-76-76",
      "19-1-54",
      "19-853-1", // Winner variants
    ],
    description: "Main match outcomes and winner markets",
  },
  {
    id: "handicap",
    label: "Handicap",
    marketKeys: [
      "3-1-1", // Handicap
      "18-1-1", // European Handicap (3 way)
      "3-1-46", // Handicap Corners
      "3-1-54", // Handicap Games
      "3-1-69", // Maps Handicap
      "3-1-76", // Points Handicap
      "3-1-87", // Handicap Sets
      "3-76-1",
      "3-76-76",
      "3-76-83", // Handicap incl. OT variants
      "3-1-60", // Match - Kill Handicap
      "3-54-54", // 1st Set: Handicap Games
    ],
    description: "Handicap and spread markets",
  },
  {
    id: "totals",
    label: "Totals",
    marketKeys: [
      "4-1-1", // Total Goals
      "4-1-46", // Total Corners
      "4-1-54", // Total Games
      "4-1-60", // Total Kills
      "4-1-69", // Total Maps
      "4-1-76", // Total Points
      "4-1-87", // Total Sets
      "4-76-1",
      "4-76-76",
      "4-76-83",
      "4-76-102", // Total variants incl. OT
      "4-1-82", // Total Rounds
    ],
    description: "Over/under and total markets",
  },
  {
    id: "both_teams_score",
    label: "Both Teams Score",
    marketKeys: [
      "9-1-1", // Both Teams To Score
      "26-1-70", // Both Teams To Score & Full Time Result
      "27-1-70", // Both Teams To Score & Total
      "11-50-1", // 1st Half - Either Team To Score
    ],
    description: "Both teams to score markets",
  },
  {
    id: "odd_even",
    label: "Odd/Even",
    marketKeys: [
      "14-1-1", // Total Goals Odd/Even
      "14-50-1", // 1st Half: Total Goals Odd/Even
      "14-55-1", // 2nd Half: Total Goals Odd/Even
      "14-50-76",
      "14-53-76",
      "14-849-76", // Total Odd/Even variants
      "14-55-76",
      "14-58-76",
      "14-62-76",
      "14-65-76", // Quarter/Half Odd/Even
      "15-76-76-1",
      "15-76-76-2", // Individual Total Odd/Even
      "14-1-76", // Total Points Odd/Even
      "14-1-54", // Total Games Odd/Even
      "14-54-54", // 1st Set: Total Games Odd/Even
    ],
    description: "Odd/even total markets",
  },
  {
    id: "1st_half",
    label: "1st Half",
    marketKeys: [
      "1-50-1",
      "1-50-76", // 1st Half - Winner/Result
      "2-50-1", // 1st Half - Double Chance
      "3-50-76",
      "3-50-83", // 1st Half - Handicap
      "4-50-76",
      "4-50-46",
      "4-50-83", // 1st Half - Total variants
      "7-50-1-1",
      "7-50-1-2", // 1st Half - Team Total Goals
      "7-50-76-1",
      "7-50-76-2", // 1st Half - Team Total Points
      "7-50-83-1",
      "7-50-83-2", // 1st Half - Team Total Runs
      "16-50-1-1",
      "16-50-1-2", // 1st Half - Team To score
      "9-50-1", // 1st Half - Both Teams To Score
      "19-50-76", // 1st Half - Winner
      "14-50-1",
      "14-50-76", // 1st Half - Odd/Even
    ],
    description: "First half markets",
  },
  {
    id: "2nd_half",
    label: "2nd Half",
    marketKeys: [
      "14-55-1", // 2nd Half: Total Goals Odd/Even
      "14-55-76", // 2nd Half: Total Odd/Even
    ],
    description: "Second half markets",
  },
  {
    id: "quarters",
    label: "Quarters",
    marketKeys: [
      "1-53-76", // 1st Quarter: Full Time Result
      "3-53-76", // 1st Quarter: Handicap
      "7-53-76-1",
      "7-53-76-2", // 1st Quarter: Individual Total
      "4-53-76", // 1st Quarter - Total
      "14-53-76", // 1st Quarter: Total Odd/Even
      "19-53-76", // 1st Quarter: Winner
      "1-58-76", // 2nd Quarter: Full Time Result
      "3-58-76", // 2nd Quarter: Handicap
      "4-58-76", // 2nd Quarter: Total
      "14-58-76", // 2nd Quarter: Total Odd/Even
      "19-58-76", // 2nd Quarter: Winner
      "3-62-76", // 3rd Quarter: Handicap
      "4-62-76", // 3rd Quarter: Total
      "14-62-76", // 3rd Quarter: Total Odd/Even
      "19-62-76", // 3rd Quarter: Winner
      "3-65-76", // 4th Quarter: Handicap
      "14-65-76", // 4th Quarter: Total Odd/Even
      "19-65-76", // 4th Quarter: Winner
    ],
    description: "Quarter-specific markets",
  },
  {
    id: "periods",
    label: "Periods",
    marketKeys: [
      "1-52-1", // 1st Period: Full Time Result
      "2-52-1", // 1st Period: Double Chance
      "4-52-1", // 1st Period: Total Goals
      "9-52-1", // 1st Period: Both Teams To Score
      "1-758-1", // 2nd Period: Full Time Result
      "2-758-1", // 2nd Period: Double Chance
      "4-758-1", // 2nd Period: Total Goals
      "9-758-1", // 2nd Period: Both Teams To Score
      "1-759-1", // 3rd Period: Full Time Result
      "2-759-1", // 3rd Period: Double Chance
      "4-759-1", // 3rd Period: Total Goals
      "9-759-1", // 3rd Period: Both Teams To Score
    ],
    description: "Period-specific markets",
  },
  {
    id: "team_specific",
    label: "Team Specific",
    marketKeys: [
      "7-1-1-1",
      "7-1-1-2", // Team Total Goals
      "7-1-54-1",
      "7-1-54-2", // Player Total Games
      "7-1-60-1",
      "7-1-60-2", // Team Total Kills
      "7-76-1-1",
      "7-76-1-2", // Team Total Goals incl. OT
      "7-76-76-1",
      "7-76-76-2", // Team Total Points incl. OT
      "7-76-83-1",
      "7-76-83-2", // Team Total Runs
      "16-1-1-1",
      "16-1-1-2", // Team To score
      "7-1-76-1",
      "7-1-76-2", // Team Individual Total Points
    ],
    description: "Team and player specific markets",
  },
  {
    id: "maps",
    label: "Maps",
    marketKeys: [
      "3-78-60",
      "3-78-82", // Map 1 - Handicap variants
      "4-78-60",
      "4-78-82", // Map 1 - Total variants
      "7-78-82-1",
      "7-78-82-2", // Map 1 - Team Total Rounds
      "7-78-60-1",
      "7-78-60-2", // Map 1 - Team Total Kills
      "19-78-69",
      "19-78-82", // Map 1 - Winner
      "20-31-1", // Map 1 - Winner
      "23-78-71", // Map 1 - Overtime
      "24-78-43",
      "24-78-52",
      "24-78-81",
      "24-78-95", // Map 1 - First events
      // Map 2
      "3-140-60",
      "3-140-82", // Map 2 - Handicap variants
      "4-140-60",
      "4-140-82", // Map 2 - Total variants
      "7-140-82-1",
      "7-140-82-2", // Map 2 - Team Total Rounds
      "7-140-60-1",
      "7-140-60-2", // Map 2 - Team Total Kills
      "19-140-69",
      "19-140-82", // Map 2 - Winner
      "23-140-71", // Map 2 - Overtime
      "24-140-43",
      "24-140-52",
      "24-140-81",
      "24-140-95", // Map 2 - First events
      // Map 3+
      "3-202-60",
      "3-202-82",
      "4-202-60",
      "4-202-82", // Map 3 variants
      "7-202-82-1",
      "7-202-82-2",
      "7-202-60-1",
      "7-202-60-2", // Map 3 team totals
      "19-202-69",
      "19-202-82",
      "21-32-1", // Map 3 winner
      "23-202-71", // Map 3 - Overtime
      "24-202-43",
      "24-202-52",
      "24-202-81",
      "24-202-95", // Map 3 - First events
      "19-264-69", // Map 4 - Winner
      "19-326-69", // Map 5 - Winner
    ],
    description: "Map-specific markets for esports",
  },
  {
    id: "sets",
    label: "Sets",
    marketKeys: [
      "19-54-54", // Winner of the 1st set
      "19-54-87", // 1st Set: Winner
      "19-54-76", // 1st Set: Winner
      "3-54-54", // 1st Set: Handicap Games
      "7-54-54-1",
      "7-54-54-2", // 1st Set: Team Individual Total Games
      "4-54-54", // 1st Set: Total Games
      "14-54-54", // 1st Set: Total Games Odd/Even
    ],
    description: "Set-specific markets for tennis",
  },
  {
    id: "special",
    label: "Special",
    marketKeys: [
      "9-76-83", // Who first
      "25-1-1", // Who next (3 way)
      "28-1-70", // Full Time Result & Total
      "29-76-70", // Winner of match & Total
      "33-1-1", // Half with most Goals
      "37-1-51", // Fight go to distance
      "16-1-69-1",
      "16-1-69-2", // Will Team Win At Least One Map
      "19-755-1", // To Qualify
      "19-756-1", // To Win Competition
      "19-757-1", // To Take 3rd Place
    ],
    description: "Special and combination markets",
  },
]

// Helper function to get market group by market key
export const getMarketGroupByKey = (
  marketKey: string
): AzuroMarketGroup | undefined => {
  return AZURO_MARKET_GROUPS.find(group => group.marketKeys.includes(marketKey))
}

// Helper function to check if market belongs to a group
export const isMarketInGroup = (
  marketKey: string,
  groupId: string
): boolean => {
  const group = AZURO_MARKET_GROUPS.find(g => g.id === groupId)
  return group ? group.marketKeys.includes(marketKey) : false
}

// Get all market keys for a specific group
export const getMarketKeysForGroup = (groupId: string): string[] => {
  const group = AZURO_MARKET_GROUPS.find(g => g.id === groupId)
  return group ? group.marketKeys : []
}
